module.exports = __webpack_public_path__ + "static/media/slide-bg2.1b41e648.jpg";